import { request } from '../utils/http';
import defaultSettings from './defaultSettings';
export default class EmapPlugin {
  constructor(options) {
    this.options = options;
  }

  settings() {
    if (typeof this.options === 'function') {
      return { ...defaultSettings,
        ...this.options()
      };
    }

    return { ...defaultSettings,
      ...this.options
    };
  }

  install(ctx) {
    const self = this; // const { settings } = self

    let fileId = ''; // 下载模板

    ctx.plugin('download-template', async (vm, cb) => {
      const {
        app,
        module,
        page,
        action,
        storeId,
        downloadTplName: filename,
        templateUrl,
        contextPath,
        params = {},
        getTemplateDownloadUrl
      } = self.settings();
      const tpUrl = templateUrl || `${contextPath}/sys/emapcomponent/imexport/importTemplate.do`;

      try {
        const res = await request({
          url: tpUrl,
          body: {
            app,
            module,
            page,
            action,
            filename,
            storeId,
            ...params
          }
        });

        if (res && res.attachment) {
          const fileUrl = getTemplateDownloadUrl ? getTemplateDownloadUrl(res.attachment) : `${contextPath}/sys/emapcomponent/file/getAttachmentFile/${res.attachment}.do`;
          window.open(fileUrl);
        } else {
          vm.$message({
            message: '模板地址请求错误',
            type: 'error'
          });
        }
      } catch (e) {
        vm.$message({
          message: '模板下载错误',
          type: 'error'
        });
      }
    }); // 文件上传

    ctx.plugin('upload-file', async (vm, file, cb) => {
      const {
        storeId,
        contextPath,
        beforeTmpFile,
        beforeUpload,
        isSingle,
        uploadTempUrl,
        uploadUrl,
        fileName
      } = self.settings();
      const scope = `${new Date().getTime()}${parseInt(Math.random() * 100).toString()}`;
      const fileToken = scope + 1;

      try {
        // 临时保存
        const res = await request(beforeTmpFile({
          url: uploadTempUrl || `${contextPath}/sys/emapcomponent/file/uploadTempFile.do`,
          body: {
            [fileName]: file,
            fileName: file.name,
            isSingle,
            scope,
            fileToken,
            storeId
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }));
        fileId = res.id; // 正式保存

        await request(beforeUpload({
          url: uploadUrl || `${contextPath}/sys/emapcomponent/file/saveAttachment/${scope}/${fileToken}.do`,
          body: {
            fileToken,
            scope,
            attachmentParam: JSON.stringify({
              fileToken,
              scope,
              attachmentParam: {
                storeId
              }
            })
          }
        }));
        const result = {
          fileToken: fileToken
        };
        cb(result);
      } catch (e) {
        console.error(e);
        cb(null);
      }
    }); // 获取导入行数

    ctx.plugin('rownum', async (vm, _, cb) => {
      const {
        app,
        module,
        page,
        action,
        storeId,
        rownumUrl,
        contextPath,
        params = {},
        beforeRownum,
        afterRownum
      } = self.settings();
      const requestConfig = {
        url: rownumUrl || `${contextPath}/sys/emapcomponent/imexport/importRownum.do`,
        body: {
          app,
          module,
          page,
          action,
          storeId,
          attachment: fileId,
          ...params
        }
      };

      try {
        let res = afterRownum(await request(beforeRownum(requestConfig)));
        res = {
          rownum: res.rowNumber
        };
        cb(res);
      } catch (e) {
        console.error(e.message);
        cb(null);
      }
    }); // 执行导入

    ctx.plugin('import', async (vm, _, cb) => {
      const {
        app,
        module,
        page,
        action,
        storeId,
        contextPath,
        params = {},
        afterImport,
        beforeImport,
        importUrl,
        getResultDownloadUrl
      } = self.settings();
      const requestConfig = {
        url: importUrl || `${contextPath}/sys/emapcomponent/imexport/import.do`,
        body: {
          app,
          module,
          page,
          action,
          storeId,
          attachment: fileId,
          ...params
        }
      };

      try {
        let res = await afterImport(request(beforeImport(requestConfig)));
        const downloadUrl = getResultDownloadUrl ? getResultDownloadUrl(res.attachment) : `${contextPath}/sys/emapcomponent/file/getAttachmentFile/${res.attachment}.do`;
        res = { ...res,
          url: downloadUrl
        };
        cb(res);
      } catch (e) {
        console.error(e.message);
        cb(null);
      }
    });
  }

}